import { Button } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className='flex justify-center items-center flex-col w-full h-screen'>
    <div className="text-center py-10 ">
      <h1 className="text-4xl font-bold text-red-500">404 - Page Not Found</h1>
      <p className="text-gray-600 mt-4">Sorry, the page you are looking for doesn't exist.</p>
      <Link to={'/'}><Button color='danger' variant='solid' className='my-5'>Refresh</Button></Link>
    </div>
    </div>
  );
};

export default NotFound;
